const A = {
  AffiliateId: "AFFILIATE_ID",
  AffiliateLang: "AFFILIATE_LANG",
  BannerId: "AFFILIATE_BANNER_ID",
  IsAnimationPlayed: "ANIMATION_PLAYED",
  IsCookiePolicyAccepted: "COOKIE_POLICY_ACCEPTED",
  IsCountrySoftBlocked: "COUNTRY_IS_SOFT_BLOCKED",
  IsFirstLogin: "FIRST_LOGIN",
  LocaleDataFetchCache: "LOCALE_DATA_FETCH_CACHE",
  PreventDataRefetching: "PREVENT_DATA_REFETCHING",
  Referrer: "AFFILIATE_REFERRER",
  TrackerId: "AFFILIATE_TRACKER_ID",
  UserLocale: "USER_LOCALE"
};
export {
  A as Cookies
};
